<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M19 4C20.6569 4 22 5.34315 22 7V9C22 9.55228 21.5523 10 21 10C19.8954 10 19 10.8954 19 12C19 13.0544 19.8159 13.9182 20.8507 13.9945L21.1166 14.0067C21.614 14.0645 22 14.4872 22 15V17C22 18.6569 20.6569 20 19 20H5C3.34315 20 2 18.6569 2 17V15C2 14.4872 2.38604 14.0645 2.88338 14.0067L3.14926 13.9945C4.18412 13.9182 5 13.0544 5 12C5 10.8954 4.10457 10 3 10C2.44772 10 2 9.55228 2 9V7C2 5.34315 3.34315 4 5 4H19ZM13 6H5C4.44772 6 4 6.44772 4 7V8.12602C5.72523 8.57006 7 10.1362 7 12C7 13.8638 5.72523 15.4299 4 15.874V17C4 17.5523 4.44772 18 5 18H13V17C13 16.4477 13.4477 16 14 16C14.5523 16 15 16.4477 15 17V18H19C19.5523 18 20 17.5523 20 17V15.874C18.2748 15.4299 17 13.8638 17 12C17 10.2052 18.1821 8.68648 19.8102 8.17993L20 8.12602V7C20 6.44772 19.5523 6 19 6H15V7C15 7.55228 14.5523 8 14 8C13.4477 8 13 7.55228 13 7V6ZM14 10C14.5523 10 15 10.4477 15 11V13C15 13.5523 14.5523 14 14 14C13.4477 14 13 13.5523 13 13V11C13 10.4477 13.4477 10 14 10Z"
    fill="currentColor"
  />
</svg>
